import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { galleryFilters, galleryItems } from '../data/gallery';
import type { GalleryCategory } from '../types/content';
export function Gallery() {
  const [filter, setFilter] = useState<GalleryCategory | 'all'>('all');
  const visible = galleryItems.filter(item => filter === 'all' || item.categories.includes(filter));
  return <section id="work" className="scroll-mt-20 bg-white py-20 lg:py-28" aria-labelledby="gallery-title" data-id="element-53" data-mp="2pmseg61t99tv">
      <div className="mx-auto max-w-7xl px-5 lg:px-8" data-id="element-54" data-mp="2kpiie7jx1zx2">
        <h2 id="gallery-title" className="section-title max-w-3xl" data-id="element-55" data-mp="2zddbhp1u66ao">
          Pool Transformations Across Central Florida
        </h2>

        <div className="-mx-5 mt-8 overflow-x-auto px-5 pb-1 lg:mx-0 lg:px-0" data-id="element-56" data-mp="2ullw8ao4rmzu">
          <div role="tablist" aria-label="Filter projects" className="flex w-max gap-2" data-id="element-57" data-mp="26wj4g9zs8drm">
            {galleryFilters.map(f => {
            const on = filter === f.id;
            return <button key={f.id} type="button" role="tab" aria-selected={on} onClick={() => setFilter(f.id)} className={`whitespace-nowrap rounded-full px-5 py-2.5 text-[15px] font-semibold transition-colors duration-150 ease-out focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-cyan ${on ? 'bg-navy text-white' : 'bg-cyan-50 text-navy hover:bg-cyan-100'}`} data-id="element-58" data-mp="rd2umv4w7ivc">
                  {f.label}
                </button>;
          })}
          </div>
        </div>

        <ul className="mt-8 grid auto-rows-[260px] grid-flow-dense gap-4 md:auto-rows-[220px] md:grid-cols-3 lg:auto-rows-[250px]" data-id="element-59" data-mp="hd2bb970x2r5">
          <AnimatePresence mode="popLayout" initial={false} data-id="element-60" data-mp="1stsj2wr3i2mv">
            {visible.map(item => <motion.li key={item.id} layout initial={{
            opacity: 0,
            scale: 0.97
          }} animate={{
            opacity: 1,
            scale: 1
          }} exit={{
            opacity: 0,
            scale: 0.97
          }} transition={{
            duration: 0.22,
            ease: [0.23, 1, 0.32, 1]
          }} className={`relative overflow-hidden rounded-2xl bg-navy-900 ${item.span}`} data-id="element-61" data-mp="1xsdac6oddbz6">
                {item.beforeImage ? <div className="grid h-full grid-cols-2 gap-0.5" data-id="element-62" data-mp="2q9tk3ncr40f">
                    <div className="relative" data-id="element-63" data-mp="3b6bpoi56xywd">
                      <img src={item.beforeImage} alt={`Before: ${item.title.toLowerCase()}`} className="h-full w-full object-cover" data-id="element-64" data-mp="3b2xlr5gvphmt" />
                      <span className="absolute left-3 top-3 rounded-md bg-navy-900/80 px-2.5 py-1 text-xs font-semibold text-white" data-id="element-65" data-mp="3kvliy1brtnm2">Before</span>
                    </div>
                    <div className="relative" data-id="element-66" data-mp="3g2k1blk6j9ys">
                      <img src={item.image} alt={item.imageAlt} className="h-full w-full object-cover" data-id="element-67" data-mp="2sdr1vf4cmjzf" />
                      <span className="absolute left-3 top-3 rounded-md bg-white px-2.5 py-1 text-xs font-semibold text-navy" data-id="element-68" data-mp="2newjufe7gzgd">After</span>
                    </div>
                  </div> : <img src={item.image} alt={item.imageAlt} className="h-full w-full object-cover" data-id="element-69" data-mp="17pybnu4gvhoy" />}
                <div className="absolute inset-x-3 bottom-3 rounded-xl bg-white/95 px-4 py-3 backdrop-blur" data-id="element-70" data-mp="tuvxkjpgum12">
                  <p className="text-sm font-bold text-navy" data-id="element-71" data-mp="xw7pivvtbjcf">{item.title}</p>
                  <p className="text-xs text-navy/65" data-id="element-72" data-mp="1loxzizk5nsk2">{item.detail}</p>
                </div>
              </motion.li>)}
          </AnimatePresence>
        </ul>
      </div>
    </section>;
}